export default class LinkButton {
  static types = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
  };

  static cmsValueList = Object.keys(LinkButton.types);
}
